export default __webpack_public_path__ + "static/media/social-02.567a6d61.jpg";